// extracted by mini-css-extract-plugin
export default {"logoVideo":"LogoVideo_logoVideo__f-Wov"};